import { faTimes } from '@fortawesome/pro-regular-svg-icons'
import { Button } from '@karnov/kui-react'

import { useScrollBoundary } from 'hooks/useScrollBoundary'
import { useTranslation } from 'services/i18n'

import { useReferencesPanelScrollContainer } from 'stores/useActiveMessageAndReferenceStore'

import { cn } from 'utils/cn'

import { InlineReferenceValidationToggle } from './InlineReferenceValidationToggle'

import type { FC } from 'react'

type Props = {
  messageId: string
  onClose?: VoidFunction
  referenceCount: number
  showReferencesCount: boolean
}

export const ReferencesPanelHeader: FC<Props> = ({ messageId, onClose, referenceCount, showReferencesCount }) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.references_panel',
  })

  const referencesScrollContainer = useReferencesPanelScrollContainer(messageId)
  const didScroll = useScrollBoundary({ scrollContainer: referencesScrollContainer })

  return (
    <div className={cn('z-10 sticky lg:top-0 bg-karnovnote pt-4 pb-3 pl-5 pr-4 mb-3 print:px-0 flex justify-between items-center', {
      'border-b border-light-transparent': didScroll,
    })}
    >
      <div className="flex items-baseline gap-x-2">
        <div className="font-medium">{t('header')}</div>
        {showReferencesCount && <div className="text-sm text-subdued-on-bg-karnovnote">{referenceCount}</div>}
      </div>
      <div className="flex items-center gap-x-4 print:hidden">
        <InlineReferenceValidationToggle />
        <Button isOnKarnovNote isSmall icon={faTimes} onClick={onClose} variant="plain" />
      </div>
    </div>
  )
}
